export default {"src":"/_next/static/media/ice-cream-fail.mono.0bfcbdd1.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};